<template>
  <div class="container">
    <LoadingContainer v-if="loading"/>

    <router-view
        v-else
        :portal="portal"
        :block-drivers="blockDrivers"
        :layout-categories="layoutCategories"
    />
  </div>
</template>

<script>
import http from '@/http'
import LoadingContainer from "../../../../../../components/Layout/LoadingContainer.vue";

export default {
  components: {LoadingContainer},

  model: {
    prop: 'portal'
  },

  props: {
    portal: {
      required: true,
    }
  },

  data() {
    return {
      blockDrivers: null,
      layoutCategories: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/block-drivers'),
        http.get('/api/v2/layout-categories'),
      ]).then(responses => {
        this.blockDrivers = responses[0].data.data

        this.layoutCategories = responses[1].data.data

        this.loading = false
      })
    }
  }
}
</script>